import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FolderUploadComponent } from './folder-upload.component';

@NgModule({
  declarations: [
    FolderUploadComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    FolderUploadComponent,
  ],
})
export class FolderUploadModule {}
